import { FeaturePageLandingContent } from "@/features/feature-page-landing/feature-page-landing-content";
import { Route } from "/app/apps/web/src/routes/_app/$lang/$family/index.tsx";
function FeaturePageLandingRoute() {
  const {
    family,
    locale
  } = Route.useLoaderData();
  return <FeaturePageLandingContent family={family} locale={locale} />;
}
export { FeaturePageLandingRoute as component };